import { GetterTree } from 'vuex';
import { TranslationsState, RootState } from '@/types/state';
import { StaticTranslationInterface, LanguageInterface } from '@/types/translations';


const getters: GetterTree<TranslationsState, RootState> = {
  allStaticTranslations(state): StaticTranslationInterface[] {
    return state.staticTranslations;
  },

  isDataLoaded(state): boolean {
    return state.staticTranslationsLoaded;
  },

  translationKeys(state): string[] {
    return state.translationKeys;
  },

  translationsByKey(state): (arg0: string) => StaticTranslationInterface[] | undefined {
    return (translationKey: string) => state.staticTranslations
      .filter((translation) => translation.key === translationKey);
  },

  languageByID(state): (arg0: number) => LanguageInterface | undefined {
    return (ID: number) => state.languages.find((lang) => lang.id === ID);
  },

};

export default getters;
